// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `x.topnav {
  z-index: 1039;
}
.topnav {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
}
.menu-title {
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS";
  font-size: 20px;
  color: #536b9f;
}
.me-auto {
  margin-right: auto !important;
}
.me-3 {
  margin-right: 1rem !important;
}
.d-none {
  display: none !important;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
.input-group-joined.input-group-solid {
  border: 0;
  background-color: #eef2f8;
}
.input-group-joined {
  border-color: #c5ccd6;
  border-width: 1px;
  border-style: solid;
  border-radius: 0.4375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group-joined.input-group-solid .form-control,
.input-group-joined.input-group-solid .datatable-input,
.input-group-joined.input-group-solid .input-group-text {
  background-color: transparent;
}
.navbar .form-control,
.navbar .datatable-input {
  font-size: 0.9rem;
}
.input-group-joined .form-control,
.input-group-joined .datatable-input {
  border: none;
}
.input-group > .form-control,
.input-group > .datatable-input,
.input-group > .form-select,
.input-group > .datatable-selector,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.pe-0 {
  padding-right: 0 !important;
}
/*
.form-control,
.datatable-input {
  display: block;
  width: 100%;
  padding: 0.875rem 1.125rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  color: #69707a;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #536b9f;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}*/
/* [type=search] {
    outline-offset: -2px;
    -webkit-appearance: textfield;
} */
.cls2 {
  background-color: #eef2f8;
}
input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.ms-auto {
  margin-left: auto !important;
}
.align-items-center {
  align-items: center !important;
}
.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.feather {
  height: 1rem;
  width: 1rem;
  vertical-align: top;
}

img,
svg {
  vertical-align: middle;
}
.dropdown .dropdown-toggle.show .dropdown-arrow {
  transform: rotate(90deg);
}

.dropdown .dropdown-toggle .dropdown-arrow {
  margin-left: 0.4rem;
  margin-right: 0;
  transition: transform 0.1s ease-in-out;
  font-size: 0.6em;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}
ol,
ul {
  padding-left: 2rem;
}

/* ----------------- */
.topnav {
  padding-left: 0;
  height: 3.625rem;
  z-index: 1039;
  font-size: 0.9rem;
}
.shadow {
  box-shadow: 0 0.15rem 1.75rem 0 rgba(33, 40, 50, 0.15) !important;
}
.justify-content-between {
  justify-content: space-between !important;
}
.justify-content-sm-start {
  justify-content: flex-start !important;
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}
.topnav.navbar-light .navbar-brand {
  color: #363d47;
}
.d-lg-block {
  display: block !important;
}
.me-auto {
  margin-right: auto !important;
}
.me-3 {
  margin-right: 1rem !important;
}
.d-none {
  display: none !important;
}
#layoutSidenav {
  display: flex;
}
.nav-fixed #layoutSidenav #layoutSidenav_nav {
  width: 15rem;
  height: 100vh;
  z-index: 1038;
}
.fixed-top,
.nav-fixed #layoutSidenav #layoutSidenav_nav,
.nav-fixed .topnav {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  /* z-index: 1030; */
}
/* #layoutSidenav  #layoutSidenav_nav {
    transform: translateX(0);
} */
#layoutSidenav #layoutSidenav_nav {
  flex-basis: 15rem;
  flex-shrink: 0;
  transition: transform 0.15s ease-in-out;
  transition: all 1s;
  /* z-index: 1038;
    transform: translateX(-15rem); */
}
.nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav {
  padding-top: 3.625rem;
}
.sidenav {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-wrap: nowrap;
  font-size: 0.9rem;
}
.sidenav-light {
  background-color: #fff;
  color: #212832;
}
.shadow-right {
  box-shadow: 0.15rem 0 1.75rem 0 rgba(33, 40, 50, 0.15) !important;
}
.nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav {
  padding-top: 3.625rem;
}
/* .nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav .sidenav-menu {
    overflow-y: hidden;
} */
.nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav .sidenav-menu {
  overflow-y: overlay;
  overflow-x: hidden;
}
.sidenav .sidenav-menu {
  flex-grow: 1;
}
.sidenav-menu .newI {
  width: 100%;
  background: #fff;
  margin-left: 15%;
  /* z-index: 1000; */
  position: inherit;
  margin-top: 10px;
  border-radius: 50%;
  border: 1px solid rgb(73 174 234);
  padding: 0px;
}
.sidenav-menu .profile_info {
  padding-top: 10px;
  color: #536b9f;
  font-weight: 300;
}
.nav-link {
  white-space: nowrap; /* Prevent text from wrapping */
  overflow: hidden; /* Hide overflowed text */
  text-overflow: ellipsis; /* Show ellipsis (...) for overflowed text */
  font-size: 15px;
}
.sidenav .sidenav-menu .nav {
  flex-direction: column;
  flex-wrap: nowrap;
  text-align: center;
  justify-content: space-around;
}
.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: #69707a;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.sidenav .sidenav-menu .nav .nav-link {
  display: flex;
  align-items: center;
  line-height: normal;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  position: relative;
}
.accordion li {
  border-bottom: 2px solid #f1f2f3;
  padding: 5px;
}
.sidenav-light .sidenav-menu .nav-link.active .nav-link-icon {
  color: #26345c;
}
.sidenav .sidenav-menu .nav .nav-link .nav-link-icon {
  font-size: 0.9rem;
  /* padding-right: 0.5rem; */
  display: inline-flex;
}
.sidenav-light .sidenav-menu .nav-link .nav-link-icon {
  color: #a7aeb8;
}
.nav .nav-link .nav-link-icon,
.sidenav-menu .nav-link .nav-link-icon {
  margin-right: 0.5rem;
}
.accordion li:hover {
  background-color: #f1f2f3;
}
.accordion li a:hover {
  color: #26345c;
}
.sidenav-light .sidenav-footer {
  background-color: rgba(33, 40, 50, 0.05);
}
.sidenav .sidenav-footer {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  height: 5rem;
}

.sidenav .sidenav-footer .sidenav-footer-content {
  font-size: 0.9rem;
}
.nav-fixed #layoutSidenav #layoutSidenav_content {
  padding-left: 15rem;
  top: 3.625rem;
}
.nav-fixed #layoutSidenav #layoutSidenav_content {
  padding-left: 15rem;
  top: 3.625rem;
}
#layoutSidenav #layoutSidenav_content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  flex-grow: 1;
  min-height: calc(100vh - 3.625rem);
  /* margin-left: -15rem; */
}
.py-10 {
  padding-top: 1rem !important;
  padding-bottom: 6rem !important;
}
.mb-4 {
  margin-bottom: 1.5rem !important;
}
/* .bg-gradient-primary-to-secondary {
    background-color: #0061f2 !important;
    background-image: linear-gradient(135deg, #0061f2 0%, rgba(105, 0, 199, 0.8) 100%) !important;
} */
.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}
.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}
.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}
.footer-admin.footer-light {
  color: #a7aeb8;
}
.footer-admin {
  height: 40px;
  align-items: center;
  line-height: 40px;
  background-color: #3ca8e8;
  position: fixed;
  bottom: 0;
  width: 100%;
}
.mt-auto {
  margin-top: auto !important;
}
.small {
  font-size: 0.875em;
}
.sidenav .sidenav-menu .nav {
  flex-direction: column;
  flex-wrap: nowrap;
}
.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
#mobilemenu {
  display: none;
}
.mainsidebarDashboardMenu,
.mainsidebarDashboardMenu li {
  margin: 0px;
  padding: 0px;
}
.mainsidebarDashboardMenu li {
  list-style: none;
}
@media screen and (max-width: 480px) {
  #mobilemenu {
    display: block;
  }
  #layoutSidenav_nav {
    margin-left: -240px;
  }
  #layoutSidenav_nav.MobileMenuShow {
    margin-left: 0;
  }
  .nav-fixed #layoutSidenav #layoutSidenav_content {
    padding-left: 0;
    top: 3.625rem;
  }
}
footer.footer-admin.mt-auto.footer-light p {
  color: #fff;
  margin: 0px;
  padding-left: 20px;
  font-size: 14px;
  float: left;
}
footer.footer-admin.mt-auto.footer-light a,
footer.footer-admin.mt-auto.footer-light a:hover {
  color: #fff;
  text-decoration: none;
  margin: 0px;
  padding-left: 20px;
  font-size: 14px;
  float: left;
}
.nav-link {
  color: #26345c;
}
.mainsidebarDashboardMenu li:first-child {
  border-top: 2px solid #f1f2f3;
}
.profile_pic.col-4 {
  padding-bottom: 10px;
}
.profile_info.col-8 h3 {
  white-space: nowrap;
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 20px;
}
pre {
  margin-bottom: 0;
}
.hsGprm {
  display: flex;
  align-items: stretch;
  width: 100%;
  background-color: #6db7d4 !important;
  min-height: 52px;
  border-bottom-width: 1px;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-style: solid;
}
.jWpMhA {
  display: flex;
  align-items: stretch;
  width: 100%;
  /* background-color: rgb(255, 255, 255); */
  background-color: #6db7d4 !important;
  min-height: 52px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.logoskybluecolor {
  color: #3ca8e8;
  margin-bottom: 20px;
  position: relative;
}
h3.logoskybluecolor:before {
  content: "";
  position: absolute;
  top: 35px;
  height: 5px;
  width: 55px;
  background-color: #25335b;
}

h3.logoskybluecolor:after {
  content: "";
  position: absolute;
  left: 15px;
  top: 37px;
  height: 1px;
  width: 95%;
  max-width: 255px;
  background-color: #25335b;
}
.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px; /* Adjust this value as needed */
}
.absolute-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  height: 14px;
  width: 14px;
  line-height: 14px;
  text-align: center;
  border-radius: 75%;
  background-color: yellow;
  color: red;
  font-size: 10px;
}
.bi-bell {
  font-size: "14px";
  color: #2533d5;
}
.notification-count {
  background-color: red;
  color: white;
  padding: 2px 5px;
  border-radius: 50%;
  font-size: 10px;
  height: 18px;
  width: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.DEPCalender .react-datepicker-wrapper {
  width: 100%;
}
.DEPEmployeeDetails .react-datepicker-wrapper {
  width: 215px;
}
td .react-datepicker-wrapper {
  width: 100%;
}
br {
  content: "";
  display: block;
  height: 10px;
}
body {
  background-color: #ebeef2;
}

.btn-primary {
  background-color: #337ab7;
  border: none;
  border-radius: 0px; 
}
.btn-primary:hover {
  background-color: #3492e4;
  border-color: rgb(10, 88, 202);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-success {
  background: #28a745;
  border: none;
  border-radius: 0px;
}

.btn-success:hover {
  background: #07e43a;
  border-radius: 0px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.btn-danger {
  background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%);
  border: none;
  border-radius: 0px;
}
.btn-danger:hover {
  background: #ff0101;
  border-radius: 0px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.btn-secondary {
  background: #c3c3c3;
  border: none;
  border-radius: 0px;
}

.btn-secondary:hover {
  background: #b4b5b4;
  border-radius: 0px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.btn-warning {
  background: #ffc107;
  color: #000;
  border: none;
  border-radius: 0px;
}

.btn-warning:hover {
  background: #ffcf3e;
  border-radius: 0px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;AACT;AACA;EACE,iEAAiE;EACjE,eAAe;EACf,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,wEAAwE;AAC1E;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;;;EAGE,6BAA6B;AAC/B;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,YAAY;AACd;AACA;;;;;EAKE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;;;;;;;;;;;;;;;;;;EAkBE;AACF;;;GAGG;AACH;EACE,yBAAyB;AAC3B;AACA;;;;;EAKE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,2CAA2C;EAC3C,uDAAuD;EACvD,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;AACA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,iEAAiE;AACnE;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,4EAA4E;AAC9E;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;AACf;AACA;;;EAGE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,mBAAmB;AACrB;AACA;;GAEG;AACH;EACE,iBAAiB;EACjB,cAAc;EACd,uCAAuC;EACvC,kBAAkB;EAClB;oCACkC;AACpC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,iEAAiE;AACnE;AACA;EACE,qBAAqB;AACvB;AACA;;GAEG;AACH;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB,EAAE,+BAA+B;EACpD,gBAAgB,EAAE,yBAAyB;EAC3C,uBAAuB,EAAE,4CAA4C;EACrE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,yCAAyC;EACzC,qDAAqD;EACrD,qCAAqC;EACrC,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;;;GAGG;AACH;EACE,gCAAgC;EAChC,+BAA+B;AACjC;AACA;;;;;;;EAOE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,6CAA6C;EAC7C,4CAA4C;EAC5C,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,aAAa;EACf;AACF;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;;EAEE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,oCAAoC;EACpC,gBAAgB;EAChB,wBAAwB;EACxB,wCAAwC;EACxC,0BAA0B;AAC5B;AACA;EACE,aAAa;EAEb,oBAAoB;EACpB,WAAW;EACX,0CAA0C;EAC1C,oCAAoC;EACpC,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB,EAAE,gCAAgC;AACpD;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;EACV,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C","sourcesContent":["x.topnav {\r\n  z-index: 1039;\r\n}\r\n.topnav {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n}\r\n.menu-title {\r\n  font-family: \"Gill Sans\", \"Gill Sans MT\", Calibri, \"Trebuchet MS\";\r\n  font-size: 20px;\r\n  color: #536b9f;\r\n}\r\n.me-auto {\r\n  margin-right: auto !important;\r\n}\r\n.me-3 {\r\n  margin-right: 1rem !important;\r\n}\r\n.d-none {\r\n  display: none !important;\r\n}\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n.input-group-joined.input-group-solid {\r\n  border: 0;\r\n  background-color: #eef2f8;\r\n}\r\n.input-group-joined {\r\n  border-color: #c5ccd6;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  border-radius: 0.4375rem;\r\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n.input-group {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: stretch;\r\n  width: 100%;\r\n}\r\n\r\n.input-group-joined.input-group-solid .form-control,\r\n.input-group-joined.input-group-solid .datatable-input,\r\n.input-group-joined.input-group-solid .input-group-text {\r\n  background-color: transparent;\r\n}\r\n.navbar .form-control,\r\n.navbar .datatable-input {\r\n  font-size: 0.9rem;\r\n}\r\n.input-group-joined .form-control,\r\n.input-group-joined .datatable-input {\r\n  border: none;\r\n}\r\n.input-group > .form-control,\r\n.input-group > .datatable-input,\r\n.input-group > .form-select,\r\n.input-group > .datatable-selector,\r\n.input-group > .form-floating {\r\n  position: relative;\r\n  flex: 1 1 auto;\r\n  width: 1%;\r\n  min-width: 0;\r\n}\r\n.pe-0 {\r\n  padding-right: 0 !important;\r\n}\r\n/*\r\n.form-control,\r\n.datatable-input {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0.875rem 1.125rem;\r\n  font-size: 0.875rem;\r\n  font-weight: 400;\r\n  line-height: 1;\r\n  color: #69707a;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #536b9f;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  border-radius: 0.35rem;\r\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}*/\r\n/* [type=search] {\r\n    outline-offset: -2px;\r\n    -webkit-appearance: textfield;\r\n} */\r\n.cls2 {\r\n  background-color: #eef2f8;\r\n}\r\ninput,\r\nbutton,\r\nselect,\r\noptgroup,\r\ntextarea {\r\n  margin: 0;\r\n  font-family: inherit;\r\n  font-size: inherit;\r\n  line-height: inherit;\r\n}\r\n.navbar-expand .navbar-nav {\r\n  flex-direction: row;\r\n}\r\n.ms-auto {\r\n  margin-left: auto !important;\r\n}\r\n.align-items-center {\r\n  align-items: center !important;\r\n}\r\n.navbar-nav {\r\n  --bs-nav-link-padding-x: 0;\r\n  --bs-nav-link-padding-y: 0.5rem;\r\n  --bs-nav-link-font-weight: ;\r\n  --bs-nav-link-color: var(--bs-navbar-color);\r\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\r\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\n.feather {\r\n  height: 1rem;\r\n  width: 1rem;\r\n  vertical-align: top;\r\n}\r\n\r\nimg,\r\nsvg {\r\n  vertical-align: middle;\r\n}\r\n.dropdown .dropdown-toggle.show .dropdown-arrow {\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.dropdown .dropdown-toggle .dropdown-arrow {\r\n  margin-left: 0.4rem;\r\n  margin-right: 0;\r\n  transition: transform 0.1s ease-in-out;\r\n  font-size: 0.6em;\r\n}\r\nol,\r\nul,\r\ndl {\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n}\r\nol,\r\nul {\r\n  padding-left: 2rem;\r\n}\r\n\r\n/* ----------------- */\r\n.topnav {\r\n  padding-left: 0;\r\n  height: 3.625rem;\r\n  z-index: 1039;\r\n  font-size: 0.9rem;\r\n}\r\n.shadow {\r\n  box-shadow: 0 0.15rem 1.75rem 0 rgba(33, 40, 50, 0.15) !important;\r\n}\r\n.justify-content-between {\r\n  justify-content: space-between !important;\r\n}\r\n.justify-content-sm-start {\r\n  justify-content: flex-start !important;\r\n}\r\n.navbar-expand {\r\n  flex-wrap: nowrap;\r\n  justify-content: flex-start;\r\n}\r\n.bg-white {\r\n  --bs-bg-opacity: 1;\r\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\r\n}\r\n.topnav.navbar-light .navbar-brand {\r\n  color: #363d47;\r\n}\r\n.d-lg-block {\r\n  display: block !important;\r\n}\r\n.me-auto {\r\n  margin-right: auto !important;\r\n}\r\n.me-3 {\r\n  margin-right: 1rem !important;\r\n}\r\n.d-none {\r\n  display: none !important;\r\n}\r\n#layoutSidenav {\r\n  display: flex;\r\n}\r\n.nav-fixed #layoutSidenav #layoutSidenav_nav {\r\n  width: 15rem;\r\n  height: 100vh;\r\n  z-index: 1038;\r\n}\r\n.fixed-top,\r\n.nav-fixed #layoutSidenav #layoutSidenav_nav,\r\n.nav-fixed .topnav {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  /* z-index: 1030; */\r\n}\r\n/* #layoutSidenav  #layoutSidenav_nav {\r\n    transform: translateX(0);\r\n} */\r\n#layoutSidenav #layoutSidenav_nav {\r\n  flex-basis: 15rem;\r\n  flex-shrink: 0;\r\n  transition: transform 0.15s ease-in-out;\r\n  transition: all 1s;\r\n  /* z-index: 1038;\r\n    transform: translateX(-15rem); */\r\n}\r\n.nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav {\r\n  padding-top: 3.625rem;\r\n}\r\n.sidenav {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  flex-wrap: nowrap;\r\n  font-size: 0.9rem;\r\n}\r\n.sidenav-light {\r\n  background-color: #fff;\r\n  color: #212832;\r\n}\r\n.shadow-right {\r\n  box-shadow: 0.15rem 0 1.75rem 0 rgba(33, 40, 50, 0.15) !important;\r\n}\r\n.nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav {\r\n  padding-top: 3.625rem;\r\n}\r\n/* .nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav .sidenav-menu {\r\n    overflow-y: hidden;\r\n} */\r\n.nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav .sidenav-menu {\r\n  overflow-y: overlay;\r\n  overflow-x: hidden;\r\n}\r\n.sidenav .sidenav-menu {\r\n  flex-grow: 1;\r\n}\r\n.sidenav-menu .newI {\r\n  width: 100%;\r\n  background: #fff;\r\n  margin-left: 15%;\r\n  /* z-index: 1000; */\r\n  position: inherit;\r\n  margin-top: 10px;\r\n  border-radius: 50%;\r\n  border: 1px solid rgb(73 174 234);\r\n  padding: 0px;\r\n}\r\n.sidenav-menu .profile_info {\r\n  padding-top: 10px;\r\n  color: #536b9f;\r\n  font-weight: 300;\r\n}\r\n.nav-link {\r\n  white-space: nowrap; /* Prevent text from wrapping */\r\n  overflow: hidden; /* Hide overflowed text */\r\n  text-overflow: ellipsis; /* Show ellipsis (...) for overflowed text */\r\n  font-size: 15px;\r\n}\r\n.sidenav .sidenav-menu .nav {\r\n  flex-direction: column;\r\n  flex-wrap: nowrap;\r\n  text-align: center;\r\n  justify-content: space-around;\r\n}\r\n.nav {\r\n  --bs-nav-link-padding-x: 1rem;\r\n  --bs-nav-link-padding-y: 0.5rem;\r\n  --bs-nav-link-font-weight: ;\r\n  --bs-nav-link-color: var(--bs-link-color);\r\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\r\n  --bs-nav-link-disabled-color: #69707a;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\n.sidenav .sidenav-menu .nav .nav-link {\r\n  display: flex;\r\n  align-items: center;\r\n  line-height: normal;\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n  position: relative;\r\n}\r\n.accordion li {\r\n  border-bottom: 2px solid #f1f2f3;\r\n  padding: 5px;\r\n}\r\n.sidenav-light .sidenav-menu .nav-link.active .nav-link-icon {\r\n  color: #26345c;\r\n}\r\n.sidenav .sidenav-menu .nav .nav-link .nav-link-icon {\r\n  font-size: 0.9rem;\r\n  /* padding-right: 0.5rem; */\r\n  display: inline-flex;\r\n}\r\n.sidenav-light .sidenav-menu .nav-link .nav-link-icon {\r\n  color: #a7aeb8;\r\n}\r\n.nav .nav-link .nav-link-icon,\r\n.sidenav-menu .nav-link .nav-link-icon {\r\n  margin-right: 0.5rem;\r\n}\r\n.accordion li:hover {\r\n  background-color: #f1f2f3;\r\n}\r\n.accordion li a:hover {\r\n  color: #26345c;\r\n}\r\n.sidenav-light .sidenav-footer {\r\n  background-color: rgba(33, 40, 50, 0.05);\r\n}\r\n.sidenav .sidenav-footer {\r\n  display: flex;\r\n  flex-shrink: 0;\r\n  align-items: center;\r\n  padding-left: 0.75rem;\r\n  padding-right: 0.75rem;\r\n  height: 5rem;\r\n}\r\n\r\n.sidenav .sidenav-footer .sidenav-footer-content {\r\n  font-size: 0.9rem;\r\n}\r\n.nav-fixed #layoutSidenav #layoutSidenav_content {\r\n  padding-left: 15rem;\r\n  top: 3.625rem;\r\n}\r\n.nav-fixed #layoutSidenav #layoutSidenav_content {\r\n  padding-left: 15rem;\r\n  top: 3.625rem;\r\n}\r\n#layoutSidenav #layoutSidenav_content {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  min-width: 0;\r\n  flex-grow: 1;\r\n  min-height: calc(100vh - 3.625rem);\r\n  /* margin-left: -15rem; */\r\n}\r\n.py-10 {\r\n  padding-top: 1rem !important;\r\n  padding-bottom: 6rem !important;\r\n}\r\n.mb-4 {\r\n  margin-bottom: 1.5rem !important;\r\n}\r\n/* .bg-gradient-primary-to-secondary {\r\n    background-color: #0061f2 !important;\r\n    background-image: linear-gradient(135deg, #0061f2 0%, rgba(105, 0, 199, 0.8) 100%) !important;\r\n} */\r\n.px-4 {\r\n  padding-right: 1.5rem !important;\r\n  padding-left: 1.5rem !important;\r\n}\r\n.container,\r\n.container-fluid,\r\n.container-xxl,\r\n.container-xl,\r\n.container-lg,\r\n.container-md,\r\n.container-sm {\r\n  --bs-gutter-x: 1.5rem;\r\n  --bs-gutter-y: 0;\r\n  width: 100%;\r\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\r\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n.px-4 {\r\n  padding-right: 1.5rem !important;\r\n  padding-left: 1.5rem !important;\r\n}\r\n.footer-admin.footer-light {\r\n  color: #a7aeb8;\r\n}\r\n.footer-admin {\r\n  height: 40px;\r\n  align-items: center;\r\n  line-height: 40px;\r\n  background-color: #3ca8e8;\r\n  position: fixed;\r\n  bottom: 0;\r\n  width: 100%;\r\n}\r\n.mt-auto {\r\n  margin-top: auto !important;\r\n}\r\n.small {\r\n  font-size: 0.875em;\r\n}\r\n.sidenav .sidenav-menu .nav {\r\n  flex-direction: column;\r\n  flex-wrap: nowrap;\r\n}\r\n.nav {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n#mobilemenu {\r\n  display: none;\r\n}\r\n.mainsidebarDashboardMenu,\r\n.mainsidebarDashboardMenu li {\r\n  margin: 0px;\r\n  padding: 0px;\r\n}\r\n.mainsidebarDashboardMenu li {\r\n  list-style: none;\r\n}\r\n@media screen and (max-width: 480px) {\r\n  #mobilemenu {\r\n    display: block;\r\n  }\r\n  #layoutSidenav_nav {\r\n    margin-left: -240px;\r\n  }\r\n  #layoutSidenav_nav.MobileMenuShow {\r\n    margin-left: 0;\r\n  }\r\n  .nav-fixed #layoutSidenav #layoutSidenav_content {\r\n    padding-left: 0;\r\n    top: 3.625rem;\r\n  }\r\n}\r\nfooter.footer-admin.mt-auto.footer-light p {\r\n  color: #fff;\r\n  margin: 0px;\r\n  padding-left: 20px;\r\n  font-size: 14px;\r\n  float: left;\r\n}\r\nfooter.footer-admin.mt-auto.footer-light a,\r\nfooter.footer-admin.mt-auto.footer-light a:hover {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  margin: 0px;\r\n  padding-left: 20px;\r\n  font-size: 14px;\r\n  float: left;\r\n}\r\n.nav-link {\r\n  color: #26345c;\r\n}\r\n.mainsidebarDashboardMenu li:first-child {\r\n  border-top: 2px solid #f1f2f3;\r\n}\r\n.profile_pic.col-4 {\r\n  padding-bottom: 10px;\r\n}\r\n.profile_info.col-8 h3 {\r\n  white-space: nowrap;\r\n  width: 130px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  font-size: 20px;\r\n}\r\npre {\r\n  margin-bottom: 0;\r\n}\r\n.hsGprm {\r\n  display: flex;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  background-color: #6db7d4 !important;\r\n  min-height: 52px;\r\n  border-bottom-width: 1px;\r\n  border-bottom-color: rgba(0, 0, 0, 0.12);\r\n  border-bottom-style: solid;\r\n}\r\n.jWpMhA {\r\n  display: flex;\r\n  -webkit-box-align: stretch;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  /* background-color: rgb(255, 255, 255); */\r\n  background-color: #6db7d4 !important;\r\n  min-height: 52px;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\r\n}\r\n.logoskybluecolor {\r\n  color: #3ca8e8;\r\n  margin-bottom: 20px;\r\n  position: relative;\r\n}\r\nh3.logoskybluecolor:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 35px;\r\n  height: 5px;\r\n  width: 55px;\r\n  background-color: #25335b;\r\n}\r\n\r\nh3.logoskybluecolor:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 15px;\r\n  top: 37px;\r\n  height: 1px;\r\n  width: 95%;\r\n  max-width: 255px;\r\n  background-color: #25335b;\r\n}\r\n.ellipsis-text {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 120px; /* Adjust this value as needed */\r\n}\r\n.absolute-badge {\r\n  position: absolute;\r\n  top: -8px;\r\n  right: -8px;\r\n  height: 14px;\r\n  width: 14px;\r\n  line-height: 14px;\r\n  text-align: center;\r\n  border-radius: 75%;\r\n  background-color: yellow;\r\n  color: red;\r\n  font-size: 10px;\r\n}\r\n.bi-bell {\r\n  font-size: \"14px\";\r\n  color: #2533d5;\r\n}\r\n.notification-count {\r\n  background-color: red;\r\n  color: white;\r\n  padding: 2px 5px;\r\n  border-radius: 50%;\r\n  font-size: 10px;\r\n  height: 18px;\r\n  width: 18px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.DEPCalender .react-datepicker-wrapper {\r\n  width: 100%;\r\n}\r\n.DEPEmployeeDetails .react-datepicker-wrapper {\r\n  width: 215px;\r\n}\r\ntd .react-datepicker-wrapper {\r\n  width: 100%;\r\n}\r\nbr {\r\n  content: \"\";\r\n  display: block;\r\n  height: 10px;\r\n}\r\nbody {\r\n  background-color: #ebeef2;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: #337ab7;\r\n  border: none;\r\n  border-radius: 0px; \r\n}\r\n.btn-primary:hover {\r\n  background-color: #3492e4;\r\n  border-color: rgb(10, 88, 202);\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.btn-success {\r\n  background: #28a745;\r\n  border: none;\r\n  border-radius: 0px;\r\n}\r\n\r\n.btn-success:hover {\r\n  background: #07e43a;\r\n  border-radius: 0px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n.btn-danger {\r\n  background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%);\r\n  border: none;\r\n  border-radius: 0px;\r\n}\r\n.btn-danger:hover {\r\n  background: #ff0101;\r\n  border-radius: 0px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n.btn-secondary {\r\n  background: #c3c3c3;\r\n  border: none;\r\n  border-radius: 0px;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: #b4b5b4;\r\n  border-radius: 0px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n.btn-warning {\r\n  background: #ffc107;\r\n  color: #000;\r\n  border: none;\r\n  border-radius: 0px;\r\n}\r\n\r\n.btn-warning:hover {\r\n  background: #ffcf3e;\r\n  border-radius: 0px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
